import React, { useEffect, useState } from "react";
import { Settings, Music2, Home, WifiOff } from "lucide-react";
import { useApp } from "@/context/AppContext";

export function Header({ view, setView }) {
  const { t, songs } = useApp();
  const [isOffline, setIsOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const updateConnection = () => setIsOffline(!navigator.onLine);
    window.addEventListener("online", updateConnection);
    window.addEventListener("offline", updateConnection);
    return () => {
      window.removeEventListener("online", updateConnection);
      window.removeEventListener("offline", updateConnection);
    };
  }, []);

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-20 flex items-center justify-between px-4 pt-[max(env(safe-area-inset-top),16px)] pb-3 backdrop-blur-2xl bg-black/30 border-b border-white/10"
    >
      <div className="flex items-center gap-3">
        <div className="relative h-10 w-10 rounded-xl grid place-items-center bg-gradient-to-br from-[#ff3366] to-[#a020f0] shadow-lg shadow-[#ff3366]/30">
          <Music2 className="h-5 w-5 text-white" strokeWidth={2.5} />
        </div>
        <div className="leading-tight">
          <h1 className="font-display font-extrabold text-xl tracking-tight">
            Z <span className="text-[#ff3366]">Music</span>
          </h1>
          <p className="text-[11px] text-white/50">{t("songsCount", songs.length)}</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {isOffline && (
          <span className="mr-2 inline-flex items-center gap-1.5 rounded-full border border-amber-300/30 bg-amber-300/10 px-2 py-1 text-xs text-amber-200" role="status">
            <WifiOff className="h-3.5 w-3.5" aria-hidden="true" />
            {t("offlineReady")}
          </span>
        )}
        <button
          data-testid="header-home-btn"
          aria-label={t("home")}
          onClick={() => setView("library")}
          className={`h-10 w-10 grid place-items-center rounded-full transition-colors ${view === "library" ? "text-[#ff3366]" : "text-white/60 hover:text-white"
            }`}
        >
          <Home className="h-5 w-5" />
        </button>
        <button
          data-testid="header-settings-btn"
          aria-label={t("settings")}
          onClick={() => setView("settings")}
          className={`h-10 w-10 grid place-items-center rounded-full transition-colors ${view === "settings" ? "text-[#ff3366]" : "text-white/60 hover:text-white"
            }`}
        >
          <Settings className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
